export default "__VITE_ASSET__CQZ4_won__"